import './RouteStatus.scss';

import { Neutral100 } from '@src/utils/colors';

interface RouteStatusProps {
  color: string[];
  status: string[];
  textColor?: string;
}

export const RouteStatus = ({ color, status, textColor }: RouteStatusProps) => {
  const isTextColor = Boolean(textColor);
  return (
    <div className='route-status'>
      <div className='status-wrapper'>
        <span
          className='status-wrapper-text'
          style={{ backgroundColor: color[0], color: isTextColor ? textColor : Neutral100 }}
        >
          {status[0]}
        </span>
      </div>
      {status[1] && color[1] && (
        <div className='status-wrapper'>
          <span
            className='status-wrapper-text'
            style={{ backgroundColor: color[1], color: isTextColor ? textColor : Neutral100 }}
          >
            {status[1]}
          </span>
        </div>
      )}
    </div>
  );
};
